<template>
  <section class="section">
    <form>
      <!--@submit.prevent="validateBeforeSubmit">-->
      <div class="container">
        <div class="columns">
          <div class="column is-10">
            <h1 class="title green">
              {{ $translate(this.title) | capitalize }}
              <span style="float: right;">
                {{ $translate('order') | capitalize }} :
                {{ this.order.primaryCode }}
                <br />
                {{ this.order.id_mercury ? `Mercurio ID: ${this.order.id_mercury}` : '' }}
              </span>
            </h1>
          </div>
          <div class="column has-text-right">
            <!--<b-button
              type="is-primary"
              icon-right="check"
              :disabled="!claim.answer"
              @click="checkClaim()"
            />-->
            <b-field grouped>
              <b-field>
                <b-button
                  type="is-primary"
                  icon-right="content-save-outline"
                  :disabled="activeTab != 1 || isBlocked()"
                  @click="saveClaim('saved')"
                />
              </b-field>
              <b-field>
                <b-dropdown
                  :disabled="
                    ($store.getters.user.userInfo.type == 'C' && $store.getters.user.userInfo.level == '1') ||
                      claim.status != 'saved'
                  "
                  aria-role="list"
                  position="is-bottom-left"
                  v-if="$store.getters.user.userInfo.type == 'C'"
                >
                  <b-button type="is-primary" slot="trigger" icon-right="menu" />
                  <b-dropdown-item class="pointercursor linktype" @click="checkClaim()">{{
                    $translate('close_claim')
                  }}</b-dropdown-item>
                  <b-dropdown-item class="pointercursor linktype" @click="closeClaimAsInadequate()">{{
                    $translate('close_claim_inadequate_no_answer')
                  }}</b-dropdown-item>
                </b-dropdown>
                <b-button
                  v-else
                  type="is-primary"
                  icon-right="send-outline"
                  :disabled="activeTab != 1 || isBlocked()"
                  @click="saveClaim('sent')"
                />
              </b-field>
            </b-field>
          </div>
        </div>
        <b-tabs v-model="activeTab">
          <b-tab-item>
            <div class="container">
              <b-field :label="$translate('generalInfo')" horizontal>
                <b-checkbox v-model="claim.generalInfo"></b-checkbox>
              </b-field>
              <b-field v-if="config.claimHasOrderType" :label="$translate('orderType')" horizontal>
                <b-checkbox v-model="claim.orderType"></b-checkbox>
              </b-field>

              <b-field :label="$translate('model') | capitalize" horizontal>
                <b-checkbox v-model="claim.model"></b-checkbox>
              </b-field>

              <b-field :label="$translate('footmeasurements')" horizontal>
                <b-checkbox v-model="claim.footmeasurements"></b-checkbox>
              </b-field>

              <b-field v-if="config.claimHasProdDetails" :label="$translate('prod_details')" horizontal>
                <b-checkbox v-model="claim.prod_details"></b-checkbox>
              </b-field>
            </div>
            <b-field horizontal>
              <a class="button" @click="$router.push('/orders')">{{ $translate('undo') }}</a>
            </b-field>

            <b-field horizontal>
              <a class="button is-primary" @click="activeTab = 1" :disabled="nextbutton">{{ $translate('next') }}</a>
            </b-field>
          </b-tab-item>

          <b-tab-item>
            <div class="container">
              <b-field
                :type="{ 'is-danger': errors.has('generalInfotext') }"
                :message="errors.first('generalInfotext')"
                :label="$translate('generalInfotext')"
                horizontal
                v-if="claim.generalInfo"
              >
                <template v-if="isBlocked()">{{ claim.generalInfotext }}</template>
                <template v-else>
                  <b-input
                    name="generalInfotext"
                    type="textarea"
                    v-model="claim.generalInfotext"
                    v-validate="'required'"
                  ></b-input>
                </template>
              </b-field>
              <b-field
                :type="{ 'is-danger': errors.has('generalInfoanswer') }"
                :message="errors.first('generalInfoanswer')"
                :label="$translate('generalInfoanswer')"
                horizontal
                v-if="claim.generalInfo && claim.answer"
              >
                <strong>{{ claim.generalInfoanswer }}</strong>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('orderTypetext') }"
                :message="errors.first('orderTypetext')"
                :label="$translate('orderTypetext')"
                horizontal
                v-if="claim.orderType"
              >
                <template v-if="isBlocked()">{{ claim.orderTypetext }}</template>
                <template v-else>
                  <b-input
                    name="orderTypetext"
                    type="textarea"
                    v-model="claim.orderTypetext"
                    v-validate="'required'"
                  ></b-input>
                </template>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('orderTypeanswer') }"
                :message="errors.first('orderTypeanswer')"
                :label="$translate('orderTypeanswer')"
                horizontal
                v-if="claim.orderType && claim.answer"
              >
                <strong>{{ claim.orderTypeanswer }}</strong>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('modeltext') }"
                :message="errors.first('modeltext')"
                :label="$translate('modeltext') | capitalize"
                horizontal
                v-if="claim.model"
              >
                <template v-if="isBlocked()">{{ claim.modeltext }}</template>
                <template v-else>
                  <b-input name="modeltext" type="textarea" v-model="claim.modeltext" v-validate="'required'"></b-input>
                </template>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('modelanswer') }"
                :message="errors.first('modelanswer')"
                :label="$translate('modelanswer')"
                horizontal
                v-if="claim.model && claim.answer"
              >
                <!--v-if="claim.model && (claim.answer || claim.status == 'sent')"-->
                <strong>{{ claim.modelanswer }}</strong>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('footmeasurementstext') }"
                :message="errors.first('footmeasurementstext')"
                :label="$translate('footmeasurementstext')"
                horizontal
                v-if="claim.footmeasurements"
              >
                <template v-if="isBlocked()">
                  <!-- v-if="claim.answer || claim.status == 'sent'">-->
                  {{ claim.footmeasurementstext }}
                </template>
                <template v-else>
                  <b-input
                    name="footmeasurementstext"
                    type="textarea"
                    v-model="claim.footmeasurementstext"
                    v-validate="'required'"
                  ></b-input>
                </template>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('footmeasurementsanswer') }"
                :message="errors.first('footmeasurementsanswer')"
                :label="$translate('footmeasurementsanswer')"
                horizontal
                v-if="claim.footmeasurements && claim.answer"
              >
                <!--v-if="claim.footmeasurements && (claim.answer || claim.status == 'sent')"-->
                <strong>{{ claim.footmeasurementsanswer }}</strong>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('prod_detailstext') }"
                :message="errors.first('prod_detailstext')"
                :label="$translate('prod_detailstext')"
                horizontal
                v-if="claim.prod_details"
              >
                <template v-if="isBlocked()">
                  <!--v-if="claim.answer || claim.status == 'sent'"-->
                  {{ claim.prod_detailstext }}
                </template>
                <template v-else>
                  <b-input
                    name="prod_detailstext"
                    type="textarea"
                    v-model="claim.prod_detailstext"
                    v-validate="'required'"
                  ></b-input>
                </template>
              </b-field>

              <b-field
                :type="{ 'is-danger': errors.has('prod_detailsanswer') }"
                :message="errors.first('prod_detailsanswer')"
                :label="$translate('prod_detailsanswer')"
                horizontal
                v-if="claim.prod_details && claim.answer"
              >
                <!--v-if="claim.prod_details && (claim.answer || claim.status == 'sent')"-->
                <strong>{{ claim.prod_detailsanswer }}</strong>
              </b-field>

              <b-field horizontal v-if="claim.attachbool" class="file" :label="$translate('file') | capitalize">
                <a target="_blank" v-bind:href="claim.attach">
                  <b-button>
                    {{ $translate('link_to_file') | capitalize }}
                  </b-button>
                </a>

                <b-button @click="removefile" :disabled="isBlocked()">
                  {{ $translate('remove_file') | capitalize }}
                </b-button>
              </b-field>
              <b-field
                class="file"
                :label="$translate('file') | capitalize"
                :message="errors.first('file')"
                :type="{ 'is-danger': errors.has('file') }"
                horizontal
                v-else
              >
                <b-upload v-model="claim.attach" name="file" :disabled="isBlocked()" accept="image/*, application/pdf">
                  <a class="button is-primary">
                    <b-icon icon="upload"></b-icon>
                    <span>{{ $translate('upload_button') }}</span>
                  </a>
                  <span class="file-name" v-if="claim.attach">{{ claim.attach.name }}</span>
                </b-upload>
              </b-field>

              <b-field horizontal v-if="!isBlocked()">
                <!--v-if="claim.answer != true && claim.status != 'sent'"-->
                <a class="button" @click="activeTab = 0">{{ $translate('undo') }}</a>
              </b-field>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </form>

    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import permissionMixin from '../../helpers/mixins/permissionMixin'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'ClaimForm',
  mixins: [permissionMixin],
  props: ['module'],
  components: {},
  data() {
    return {
      activeTab: 1,
      nextbutton: true,
      title: null,
      isSaveDisabled: false,
      salvable: true,
      id: undefined,
      orderid: -1,
      attachtoremove: false,
      order: {},
      claim: {
        generalInfo: false,
        orderType: false,
        model: false,
        footmeasurements: false,
        prod_details: false,
        status: undefined,
      },
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.module]
    },
  },
  watch: {
    claim: {
      deep: true,
      handler() {
        this.nextbutton = !(
          this.claim.generalInfo ||
          this.claim.orderType ||
          this.claim.model ||
          this.claim.footmeasurements ||
          this.claim.prod_details
        )
      },
    },
  },
  methods: {
    isBlocked() {
      return !(this.claim.status == 'saved' || this.claim.status == undefined)
    },
    removefile() {
      this.claim.attachbool = false
      this.claim.attach = null
      this.attachtoremove = true
    },
    async closeClaimAsInadequate() {
      this.claim.inadequate = true
      this.checkClaim()
    },
    async checkClaim() {
      // Cambia lo stato dell'ordine e conferma (chiude) il claim
      this.claim.Checktec = this.$store.getters.user.userInfo.username
      this.claim.DateCheck = new Date().getTime()
      this.claim.confirmed = true
      this.claim.status = 'confirmed'
      this.order.claims[this.id] = this.claim

      this.order.haveclaimsAdmin = false
      this.order.haveclaimsCustomer = false
      for (let index in this.order.claims) {
        if (!this.order.claims[index].deleted && !this.order.claims[index].confirmed) {
          if (this.order.claims[index].status != 'saved') {
            this.order.haveclaimsAdmin = true
            this.order.haveclaimsCustomer = true
          } else {
            if (this.claim.AdminClaim) {
              this.order.haveclaimsAdmin = true
            } else {
              this.order.haveclaimsCustomer = true
            }
          }
        }
      }

      await this.$db
        .collection('orders')
        .doc(this.orderid)
        .update({
          statusOrder: this.claim.originalStatus,
          claims: this.order.claims,
          haveclaimsAdmin: this.order.haveclaimsAdmin,
          haveclaimsCustomer: this.order.haveclaimsCustomer,
        })
        .then(() => {
          this.$router.push({ name: 'orders' })
        })
    },
    async saveClaim(newStatus) {
      this.isSaveDisabled = true
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.claim.lastModificationDate = new Date().getTime()
          this.claim.status = newStatus
          let orderStatus = this.order.statusOrder

          if (this.claim.AdminClaim) {
            //Se il claim è stato inviato lo stato cambia in standby, altrimenti rimane quello di prima
            orderStatus = newStatus == 'sent' ? 'standord' : this.order.statusOrder
          } else {
            //Se il claim è stato inviato lo stato cambia in standby, altrimenti rimane quello di prima
            orderStatus = newStatus == 'sent' ? 'segnreceiveord' : this.order.statusOrder
          }

          if (this.id == undefined) {
            this.claim.tec = this.$store.getters.user.userInfo.username
            this.claim.creationDate = new Date().getTime()
            this.claim.originalStatus = this.order.statusOrder
            if (this.order.claims) {
              this.id = this.order.claims.length
            } else {
              this.order.claims = []
              this.id = 0
            }
          }

          if (this.attachtoremove) {
            var desertRef = this.$storage.ref('order/attachment/' + this.order.id + '/claim/' + this.id)
            await desertRef.delete().then(function() {})
          }
          const storageRef = this.$storage.ref('order/attachment/' + this.order.id + '/claim/' + this.id)
          if (this.claim.attach && this.claim.attach.name) {
            await storageRef.put(this.claim.attach).then(async snapshot => {
              await snapshot.ref.getDownloadURL().then(url => {
                this.claim.attach = url
                this.claim.attachbool = true
              })
            })
          }

          if (newStatus == 'sent') {
            this.order.haveclaimsAdmin = true
            this.order.haveclaimsCustomer = true
          } else {
            if (this.claim.AdminClaim) {
              this.order.haveclaimsAdmin = true
              this.order.haveclaimsCustomer = false
            } else {
              this.order.haveclaimsAdmin = false
              this.order.haveclaimsCustomer = true
            }
          }
          this.order.claims[this.id] = this.claim
          this.$db
            .collection('orders')
            .doc(this.orderid)
            .update({
              statusOrder: orderStatus,
              claims: this.order.claims,
              haveclaimsCustomer: this.order.haveclaimsCustomer,
              haveclaimsAdmin: this.order.haveclaimsAdmin,
            })
            .then(() => {
              this.feedback(true)
              this.isSaveDisabled = false
            })
            .catch(() => {
              this.feedback(false)
              this.isSaveDisabled = false
            })
        } else {
          this.feedback(false)
          this.isSaveDisabled = false
        }
      })
    },
    feedback(isPositive) {
      let message = isPositive ? this.$translate('success_form') : this.$translate('failed_form')
      let type = isPositive ? 'is-success' : 'is-danger'
      this.$buefy.notification.open({
        duration: 3000,
        message: message,
        type: type,
      })
    },
    // async oldSave() {
    //   this.isSaveDisabled = true;
    //   this.claim.lastModificationDate = new Date().getTime();
    //   if (this.id == undefined) {
    //     this.claim.tec = this.$store.getters.user.userInfo.username;
    //     this.claim.creationDate = new Date().getTime();
    //     if (this.order.claims) {
    //       this.id = this.order.claims.length;
    //     } else {
    //       this.order.claims = [];
    //       this.id = 0;
    //     }
    //   }
    //   this.order.claims[this.id] = this.claim;

    //   await this.$db
    //     .collection("orders")
    //     .doc(this.orderid)
    //     .update({
    //       statusOrder: "standord",
    //       claims: this.order.claims
    //     });
    //   this.isSaveDisabled = false;
    // },
    // validateBeforeSubmit() {
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       this.$buefy.notification.open({
    //         duration: 3000,
    //         message: this.$translate("success_form"),
    //         type: "is-success"
    //       });
    //       this.save();
    //       return;
    //     }
    //     this.$buefy.notification.open({
    //       duration: 3000,
    //       message: this.$translate("failed_form"),
    //       type: "is-danger"
    //     });
    //   });
    // }
  },
  async created() {
    this.isSaveDisabled = true
    this.id = this.$route.params.id
    this.orderid = this.$route.params.orderid
    if (this.orderid == null) {
      this.$router.push({ name: 'orders' })
    }

    if (this.id == undefined) {
      this.title = 'new_claim'
      this.claim.AdminClaim = this.ClaimType()
      this.activeTab = 0
      await this.$db
        .collection('orders')
        .doc(this.orderid)
        .get()
        .then(doc => {
          this.order = doc.data()
        })
    } else {
      await this.$db
        .collection('orders')
        .doc(this.orderid)
        .get()
        .then(doc => {
          this.order = doc.data()
          this.claim = this.order.claims[this.id]
        })
      if (this.claim.answer) {
        this.title = 'confirm_claim'
      } else {
        this.title = 'edit_claim'
      }
      this.activeTab = 1
    }

    this.isSaveDisabled = false
  },
}
</script>
<style scoped>
.container >>> nav.tabs {
  display: none;
}
</style>
